import { useState, useEffect } from 'react';
import React from 'react';
import { jsPDF } from 'jspdf';
import { useToken } from '../TokenContext.js';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import './AdminView.css';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import loader from './../assets/loader_v1.gif';



const AdminView = ({username, updateNotification}) => {
  //console.log("username",username);
  // const [startTime, setStartTime] = useState(null);
  // const [endTime, setEndTime] = useState(null);
  const [searchQuery, setSearchQuery] = useState(''); // Add state for search
  const [expandedDepartments, setExpandedDepartments] = useState([]); // State to track expanded departments
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [loading, setLoading] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [trained, setTrained] = useState(null);
  const [userCount, setUserCount] = useState(0);
  const [sessionCount, setSessionCount] = useState(0);
  const [messageCount, setMessageCount] = useState(0);
  const [responseQuality, setResponseQuality] = useState(0);
  const [positiveCount, setPositiveCount] = useState(0);
  const [negetiveCount, setNegetiveCount] = useState(0);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [report, setReport] = useState(null);
  const [unavailableResponse, setUnavailableResponse] = useState(0);
  const [totalResponse, setTotalResponse] = useState(0);
  const [unavailableQueries, setUnavailableQueries] = useState([]);
  const [visibleTooltipId, setVisibleTooltipId] = useState(null);
  const [unresolvedQueries, setUnresolvedQueries] = useState({
    query: [],
    response: []
  });
    const [fAQ, setFAQ]= useState([]);

    const token = useToken().token;
    const companyName = useToken().companyName;

  AdminView.propTypes = {
    username: PropTypes.string.isRequired,
    updateNotification: PropTypes.func.isRequired,

  };

  // const [users, setUsers] = useState([
  //   { id: 1, totalUsers: userCount, sessions: sessionCount, messages: messageCount, lastUpdated: '2 days ago', department: 'Billing and Insurance', status: 'open' },
  //   { id: 2, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '3 days ago', department: 'Pharmacy', status: 'locked' },
  //   { id: 3, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '5 days ago', department: 'Surgery', status: 'locked' },
  //   { id: 4, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '7 days ago', department: 'Nursing', status: 'locked' },
  //   { id: 5, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '15 days ago', department: 'Cardiology', status: 'locked' },
  // ]);

  const [users, setUsers] = useState([
    { id: 1, totalUsers: userCount, sessions: sessionCount, messages: messageCount, lastUpdated: '2 days ago', department: 'HR', status: 'open' },
    { id: 2, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '3 days ago', department: 'Sales', status: 'locked' },
    { id: 3, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '5 days ago', department: 'Marketing', status: 'locked' },
    { id: 4, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '7 days ago', department: 'Engineering', status: 'locked' },
    { id: 5, totalUsers: 0, sessions: 0, messages: 0, lastUpdated: '15 days ago', department: 'Finance', status: 'locked' },
  ]);

  useEffect(() => {
    //console.log("....", isLoading);
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === 1 // Assuming you want to update user with id 4 (HR)
          ? {
            ...user,
            totalUsers: userCount,
            sessions: sessionCount,
            messages: messageCount,
          }
          : user
      )
    );
  }, [userCount, sessionCount, messageCount]);

  useEffect(() => {
    fetchResponseQuality();
  }, []);

  const fetchResponseQuality = () => {
    fetch('https://infia.enviseer.com/api/llm_backend/conversation_history/feedback_percentage', {
      method: 'GET', // Assuming it's a GET request
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //console.log('Feedback percentage data:', data);
        if (data) {
          if (data.positive_feedback_percentage !== undefined) {
            data.positive_feedback_percentage = Math.round(parseFloat(data.positive_feedback_percentage));
          }

          setResponseQuality(data.positive_feedback_percentage);
          if (data.positive_feedback_count !== undefined) {
            setPositiveCount(data.positive_feedback_count);
          }
          if (data.negative_feedback_count !== undefined) {
            setNegetiveCount(data.negative_feedback_count);
          }
        }
        // You can now use the feedback percentage data in your application
      })
      .catch((error) => {
        console.error('Error fetching feedback percentage:', error);
      });

    fetch('https://infia.enviseer.com/api/llm_backend/conversation_history/feedback_percentage', {
      method: 'GET', // Assuming it's a GET request
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //console.log('Feedback percentage data:', data);
        // You can now use the feedback percentage data in your application
      })
      .catch((error) => {
        console.error('Error fetching feedback percentage:', error);
      });


  };

  // const [admins, setAdmins] = useState([
  //   { id: 1, name: 'Rahul Lenka', status: 'Enabled', department: 'Pharmacy' },
  //   { id: 2, name: 'Devipriya', status: 'Disabled', department: 'Cardiology' },
  //   { id: 3, name: 'Vivek', status: 'Enabled', department: 'Billing and Insurance' },
  //   { id: 4, name: 'Rahul Lenka', status: 'Disabled', department: 'Billing and Insurance' },
  //   { id: 5, name: 'Mahesh Kumar', status: 'Enabled', department: 'Surgery' },
  //   { id: 6, name: 'Mahesh Kumar', status: 'Disabled', department: 'Billing and Insurance' },
  //   { id: 7, name: 'Devipriya', status: 'Enabled', department: 'Pharmacy' },
  //   { id: 9, name: 'Devipriya', status: 'Disabled', department: 'Nursing' },
  //   { id: 10, name: 'Saumya Vani', status: 'Enabled', department: 'Surgery' },
  // ]);

  const [admins, setAdmins] = useState([
    { id: 1, name: 'Rahul Lenka', status: 'Enabled', department: 'Sales' },
    { id: 2, name: 'Devipriya', status: 'Disabled', department: 'Marketing' },
    { id: 3, name: 'Vivek', status: 'Enabled', department: 'HR' },
    { id: 4, name: 'Rahul Lenka', status: 'Disabled', department: 'HR' },
    { id: 5, name: 'Mahesh Kumar', status: 'Enabled', department: 'Engineering' },
    { id: 6, name: 'Mahesh Kumar', status: 'Disabled', department: 'HR' },
    { id: 7, name: 'Devipriya', status: 'Enabled', department: 'Sales' },
    { id: 9, name: 'Devipriya', status: 'Disabled', department: 'Finance' },
    { id: 10, name: 'Saumya Vani', status: 'Enabled', department: 'Engineering' },
  ]);

  const toggleStatus = (userId) => {
    setAdmins(admins.map(user =>
      user.id === userId ? { ...user, status: user.status === 'Enabled' ? 'Disabled' : 'Enabled' } : user
    ));
  };
  // const handleDepartmentChange = (e) => {
  //   setSelectedDepartment(e.target.value);
  // };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // const handleStatusFilterChange = (e) => {
  //   setStatusFilter(e.target.value);
  // };
  const handleToggleDepartment = (department) => {
    setExpandedDepartments((prevExpandedDepartments) =>
      prevExpandedDepartments.includes(department)
        ? prevExpandedDepartments.filter((dep) => dep !== department)
        : [...prevExpandedDepartments, department]
    );
  };
  const handleEnableAll = (department) => {
    setUsers(users.map(user =>
      user.department === department ? { ...user, status: 'Enabled' } : user
    ));
  };

  const handleDisableAll = (department) => {
    setUsers(users.map(user =>
      user.department === department ? { ...user, status: 'Disabled' } : user
    ));
  };

  const departmentData = users.reduce((acc, user) => {
    if (!acc[user.department]) {
      acc[user.department] = { sessions: 0, messages: 0, totalUsers: 0, users: [], status: [] };
    }
    acc[user.department].sessions += user.sessions;
    acc[user.department].messages += user.messages;
    acc[user.department].totalUsers += user.totalUsers;
    acc[user.department].users.push(user);
    acc[user.department].status += user.status;
    return acc;
  }, {});

  const departmentDataforAdmin = admins.reduce((acc, user) => {
    if (!acc[user.department]) {
      acc[user.department] = { users: [] }; // Initialize users array for each department
    }
    acc[user.department].users.push(user); // Add the user to the department's user list
    return acc;
  }, {});

  const handleManageUsers = (department) => {
    handleToggleDepartment(department);
  };

  const filteredUsers = admins.filter(user =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // Determine which departments to expand based on the search results
  const departmentsToExpand = searchQuery
    ? [...new Set(filteredUsers.map(user => user.department))]
    : [];

  const percentage = 50 + responseQuality * 0.5; // Example percentage
  const thumbsUpCount = positiveCount;
  const thumbsDownCount = negetiveCount;

  useEffect(() => {
    fetch(`https://infia.enviseer.com/api/llm_backend/frequent_asked?company=${companyName}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        const filteredFAQs = data.slice(1).map((item) => ({
          ...item,
          question: item.question.replace(/^(\d+\.\s*)'(.*)'$/, '$1$2'),
        }));
        setFAQ(filteredFAQs);
      })
      .catch((error) => console.error('Error fetching user count:', error));
  }, []);

  // const trendingQuestions = [
  //   "How to reset my password?",
  //   "What are the company's working hours?",
  //   "How to apply for leave?",
  //   "What is the procedure for expense reimbursement?",
  //   "Where can I find the company's policies?"
  // ];

  // Function to get gradient color based on value

  const getColor = (value) => {
    if (value >= 70) {
      return 'green'; // High quality (green)
    } else if (value >= 40) {
      return '#E3921F'; // Medium quality (orange)
    } else {
      return '#CF1020'; // Low quality (red)
    }
  };

  // Updated SemiCircleProgressBar component with gradient and modern styling
  const SemiCircleProgressBar = () => {
    const score = responseQuality;
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginTop: '18px' }}>
        <div style={{ width: '150px', height: '150px', fontWeight: 'bold', marginBottom: '10px' }}>
          <CircularProgressbar
            value={score}
            text={`${score}%`}  // Show percentage
            styles={buildStyles({
              pathColor: getColor(score),
              textColor: getColor(score),
              trailColor: '#eee',
              rotation: 0.75,
              strokeLinecap: 'round', // Rounded edges for modern look
              textSize: '18px', // Modern font size
              pathTransitionDuration: 1.5, // Smooth transition
              trailWidth: 8, // Thin trail
              pathWidth: 12, // Thick path
              shadow: `0px 4px 12px rgba(0, 0, 0, 0.2)`, // Drop shadow for modern feel
            })}
            strokeWidth={15}
            circleRatio={0.5} // Semi-circle
          />
        </div>
      </div>
    );
  };


  useEffect(() => {
    // const currentTime = new Date();
    // const fiveMinutesAgo = new Date(currentTime.getTime() - 6*60 * 60000);
    // setEndTime(currentTime);
    // setStartTime(fiveMinutesAgo);
  }, []);

  // const handleStartTimeChange = (date) => {
  //   if (endTime) {
  //       const startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  //       const endDate = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate());
  //       if (startDate > endDate) {
  //           return;
  //       }
  //       if (startDate.getTime() === endDate.getTime() && date >= endTime) {
  //           return;
  //       }
  //   }
  //   setStartTime(date);
  // };

  // const handleEndTimeChange = (date) => {
  //   const currentTime = new Date();
  //   if (!startTime) {
  //       return;
  //   }
  //   const startDate = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate());
  //   const endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  //   setEndTime(date);
  // };

  // const filterPassedTime = (time) => {
  //     const currentTime = new Date();
  //     const selectedTime = new Date(time);
  //     return currentTime.getTime() >= selectedTime.getTime();
  // };


  // const handleLastDurationChange = (event) => {
  //   const selectedDuration = event.target.value;
  //   setLastDuration(selectedDuration);

  //   const currentTime = new Date();
  //   let newStartTime = null;
  //   let newEndTime = currentTime;

  //   switch (selectedDuration) {
  //       case '1 day':
  //           newStartTime = new Date(currentTime.getTime() - 24 * 60 * 60000);
  //           break;
  //       case '1 week':
  //           newStartTime = new Date(currentTime.getTime() - 7 * 24 * 60 * 60000);
  //           break;
  //       case '1 Month':
  //           newStartTime = new Date(currentTime.getTime() - 30 * 24 * 60 * 60000);
  //           break;
  //       case '3 Month':
  //           newStartTime = new Date(currentTime.getTime() - 3*30 * 24 * 60 * 60000);
  //           break;
  //       case '6 Month':
  //           newStartTime = new Date(currentTime.getTime() - 6*30 * 24 * 60 * 60000);
  //           break;
  //       case '1 Year':
  //           newStartTime = new Date(currentTime.getTime() - 365 * 24 * 60 * 60000);
  //           break;
  //       case 'Custom time range':
  //           newStartTime = null;
  //           newEndTime = null;
  //           break;
  //       default:
  //           newStartTime = startTime;
  //           newEndTime = endTime;
  //           break;
  //   }

  //   setStartTime(newStartTime);
  //   setEndTime(newEndTime);
  // };

  // const handleRefresh = () => {
  //   // Get the current time
  //   let currentTime = new Date();

  //   // Calculate the new start time based on the selected duration
  //   let newStartTime = null;

  //   switch (lastDuration) {
  //       case '1 day':
  //           newStartTime = new Date(currentTime.getTime() - 24 * 60 * 60000);
  //           break;
  //       case '1 week':
  //           newStartTime = new Date(currentTime.getTime() - 7 * 24 * 60 * 60000);
  //           break;
  //       case '1 Month':
  //             newStartTime = new Date(currentTime.getTime() - 30 * 24 * 60 * 60000);
  //           break;
  //       case '3 Month':
  //             newStartTime = new Date(currentTime.getTime() - 3*30 * 24 * 60 * 60000);
  //           break;
  //       case '6 Month':
  //             newStartTime = new Date(currentTime.getTime() - 6*30 * 24 * 60 * 60000);
  //           break;
  //       case '1 Year':
  //             newStartTime = new Date(currentTime.getTime() - 365 * 24 * 60 * 60000);
  //           break;
  //       case 'Custom time range':
  //           // If custom time range is selected, don't update startTime or endTime
  //           newStartTime = startTime;
  //           currentTime = endTime;
  //           break;
  //       default:
  //           newStartTime = startTime;
  //           currentTime = endTime;
  //           break;
  //   }

  //   // Update the state with the new times
  //   setStartTime(newStartTime);
  //   setEndTime(currentTime);

  //   // Increment refreshKey to trigger re-fetching of data
  //   setRefreshKey(prevKey => prevKey + 1);
  // };
  const [showModal, setShowModal] = useState(false);

  const handleUploadClick = async (event, department) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setLoading(department);

      // Prepare the form data for the file
      const formData = new FormData();
      formData.append('files', file); // Append the file to FormData

      // Prepare the query parameters
      const company = companyName;
      const docType = 'HR';
      const queryParams = new URLSearchParams({ company, doc_type: docType });

      try {
        // Make the POST request with the file in FormData and query params in the URL
        const response = await fetch(`https://infia.enviseer.com/api/llm/upload_pdfs?${queryParams}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',  // Make sure to set the content type if needed
            'Authorization': `Bearer ${token}`,  // Adding the token to the Authorization header
          },
          body: formData, // Only the file is sent in the form data
        });

        // Check if the response is OK
        if (response.ok) {
          const responseData = await response.json();
          //console.log('Response JSON:', responseData);
          setUploadedDocs([...uploadedDocs, file.name]); // Add file name to the uploadedDocs array
          setTrained(department); // Simulate training completion
          addNotification(file.name);
        } else {
          const errorText = await response.text();
          console.error('Error:', response.statusText, errorText);
        }
      } catch (error) {
        console.error('Request failed:', error);
      } finally {
        setLoading(null); // Stop showing the loading gif
      }
    }
  };
  //console.log("nhbcnh",fAQ);
  // const faqs = [
  //   { question: "Admission Process & registration?"},
  //   { question: "Patient rights and responsibilities?"},
  //   { question: "Guide for Billing and Payment Procedures?"},
  //   { question: "General Guidelines for Surgery?"},
  // ];

  const faqs = [
    { question: "How to apply for leave?"},
    { question: "What are the health benefits?"},
    { question: "How to update my personal information?"},
    { question: "What is the policy for working from home?"},
  ];

  const addNotification = (fileName) => {
    const timestamp = new Date().toISOString();
    const newNotification = {
      message: `File <strong>${fileName}</strong> uploaded successfully.`,
      time: timestamp,
    };
    updateNotification(newNotification);
  };

  // Fetch uploaded documents when the component mounts
  useEffect(() => {
    fetchUploadedDocs();
    // fetchChatHistory();
    fetchAllHistories();
  }, []);
  const fetchUploadedDocs = async () => {
    const company = companyName;
    const docType = 'HR';

    try {
      // Create FormData to send as form data
      const formData = new FormData();
      formData.append('company', company);
      formData.append('doc_type', docType);

      // Fetch the list of uploaded documents with a POST request
      const response = await fetch(`https://infia.enviseer.com/api/llm/get_files?company=${companyName}&doc_type=HR`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',  // Make sure to set the content type if needed
          'Authorization': `Bearer ${token}`,  // Adding the token to the Authorization header
        },
      });

      if (response.ok) {
        const data = await response.json(); // Assuming the API returns a JSON response
        setUploadedDocs(data.files); // Update the state with the list of documents
        //console.log("kkkkkkkkkkk", uploadedDocs);
      } else {
        const errorText = await response.text();
        console.error('Error:', response.statusText, errorText);
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
    }
  };


  const handleSeeAllClick = () => {
    fetchUploadedDocs(); // Call the function to fetch documents
    setShowModal(true);  // Show the modal after fetching documents
  };


  const handleClose = () => {
    setShowModal(false);
  };



  useEffect(() => {
    // Fetch User Count
    fetch('https://infia.enviseer.com/api/llm_backend/users/count', {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        setUserCount(data.count);
      })
      .catch((error) => console.error('Error fetching user count:', error));

    // Fetch Session Count
    fetch('https://infia.enviseer.com/api/llm_backend/sessions/count', {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        setSessionCount(data.count);
      })
      .catch((error) => console.error('Error fetching session count:', error));

    // Fetch Message Count
    fetch('https://infia.enviseer.com/api/llm_backend/conversation_history/count', {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        setMessageCount(data.count);
      })
      .catch((error) => console.error('Error fetching message count:', error));
  }, []);


  const handleSelect = (doc) => {
    setSelectedDocs((prevSelectedDocs) =>
      prevSelectedDocs.includes(doc)
        ? prevSelectedDocs.filter((item) => item !== doc)
        : [...prevSelectedDocs, doc]
    );
  };

  const deletePDFs = async () => {
    const url = `https://infia.enviseer.com/api/llm/delete_pdfs?company=${companyName}&doc_type=HR`;
    const data = selectedDocs;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',  // Make sure to set the content type if needed
          'Authorization': `Bearer ${token}`,  // Adding the token to the Authorization header
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        //console.log('PDF deleted successfully:', result);

        await fetchUploadedDocs();
      } else {
        console.error('Error deleting PDF:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  };

const handleGenerateReport = () => {
  setReport(reportData);
  setShowReport(true);
};

function handleDownloadUnresolvedRequests() {
  const csvData = unresolvedQueries.query.map(query => `"${query}"`).join("\n");
  downloadCSV(csvData, 'unresolved_requests.csv');
}

function handleDownloadUnresolvedWithResponse() {
  const csvData = unresolvedQueries.query.map((query, index) => {
    const response = unresolvedQueries.response[index] || ''; // Use response or fallback to an empty string if not available
    return `"${query}","${response}"`;
  }).join("\n");
  
  downloadCSV(csvData, 'unresolved_requests_with_response.csv');
}

function handleDownloadIrrelevantRequests() {
  const csvData = unavailableQueries.map(query => `"${query}"`).join("\n");
  downloadCSV(csvData, 'irrelevant_requests.csv');
}

function downloadCSV(csvContent, filename) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}


function handleDownloadWholeReport() {
  const doc = new jsPDF();
  
  // Set main header
  doc.setFontSize(18);
  doc.text("Report Summary", 20, 20); // Add margin to the left
  
  // Add horizontal line under the main header
  doc.line(20, 25, 190, 25);
  
  // Set content below the header
  doc.setFontSize(12);
  doc.text("Department: HR", 20, 35);
  doc.text(`Total Users: ${departmentData['HR'].totalUsers}`, 20, 45);
  doc.text(`Total Sessions: ${departmentData['HR'].sessions}`, 20, 55);
  doc.text(`Total Messages: ${departmentData['HR'].messages}`, 20, 65);
  doc.text(`Query Relevance Rate: ${Math.round(((totalResponse - unavailableResponse) / totalResponse) * 100)}%`, 20, 75);
  doc.text(`Response Quality: ${percentage}%`, 20, 85);
  
  // Add section separator
  doc.line(20, 95, 190, 95);
  
  // Request Summary Section
  doc.setFontSize(14);
  doc.text("Request Summary:", 20, 105);
  
  // Add content with margin
  doc.setFontSize(12);
  doc.text(`Total Unresolved Requests: ${unresolvedQueries.query.length}`, 20, 115);
  doc.text(`Total Irrelevant Requests: ${unavailableQueries.length}`, 20, 125);
  
  // Add another section separator
  doc.line(20, 135, 190, 135);
  
  // Add "Top Unresolved Requests" section
  doc.setFontSize(14);
  doc.text("Top Unresolved Requests:", 20, 145);
  doc.setFontSize(12);
  if (unresolvedQueries.query.length > 0) {
    unresolvedQueries.query.slice(0, 5).forEach((query, index) => {
      doc.text(`${index + 1}. ${query}`, 25, 155 + (index * 10)); // List with bullet points
    });
  } else {
    doc.text("No unresolved requests.", 25, 155); // Show a message if no unresolved requests
  }

  // Add "Top Irrelevant Requests" section
  doc.setFontSize(14);
  doc.text("Top Irrelevant Requests:", 20, 175);
  doc.setFontSize(12);
  if (unavailableQueries.length > 0) {
    unavailableQueries.slice(0, 5).forEach((query, index) => {
      doc.text(`${index + 1}. ${query}`, 25, 185 + (index * 10)); // List with bullet points
    });
  } else {
    doc.text("No irrelevant requests.", 25, 185); // Show a message if no irrelevant requests
  }

  // Save the PDF
  doc.save('report.pdf');
}


  const reportData = [
    "Query 1 failed due to timeout",
    "Query 2 failed due to syntax error",
    "Query 3 failed due to missing data"
  ];

  const handleReportClose = () => {
    setShowReport(false);
  };

// Fetch session history for multiple sessions
// const fetchAllSessionHistories = async (sessionIdsList) => {
//   setIsLoading(true);
  
//   let allHistories = []; // To store histories of all sessions
//   let totalResponseCount = 0; // To count total responses
//   let unavailableResponseCount = 0; // To count unavailable responses
//   let queriesWithUnresolvedResponse = {
//     query: [],
//     response: []
//   };
//     let queriesWithUnavailableResponse = []; // To store queries with unavailable responses

//     try {
//       // Loop through each session ID in the sessionIdsList
//       for (let sessionId of sessionIdsList) {
//         //console.log("Fetching session history for:", sessionId);

//         const response = await fetch(`https://infia.enviseer.com/api/llm_backend/session/history`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ session_id: sessionId }),
//         });

//         if (!response.ok) {
//           throw new Error(`Failed to fetch session history for session ${sessionId}`);
//         }

//         const data = await response.json();
//         allHistories.push({
//           sessionId,
//           history: data
//         });

//       // Count responses and check for unavailable responses
//       data.forEach((message, index) => {
//         if (message.sender === "bot") {
//           totalResponseCount++;
//           if(message.feedback===-1){ 
//             queriesWithUnresolvedResponse.response.push(message.text);
//            for (let j = index - 1; j >= 0; j--) {
//             if (data[j].sender === "user") {
//               queriesWithUnresolvedResponse.query.push(data[j].text);
//               break;
//             }
//           }
//           }
//           if (message.text.includes("The required information is not available in the current context")||message.text.includes("information in the provided context")||message.text.includes("provide more context")||message.text.includes("not contain any information")) {
//             unavailableResponseCount++;

//               // Find the corresponding user query (last user query before this response)
//               for (let j = index - 1; j >= 0; j--) {
//                 if (data[j].sender === "user") {
//                   queriesWithUnavailableResponse.push(data[j].text);
//                   break;
//                 }
//               }
//             }
//           }
//         });
//       }

//     // Set the accumulated history to state
//     //console.log('unresolvedResponse', queriesWithUnresolvedResponse);
//     //console.log('All session histories fetched:', allHistories);
//     //console.log('Total responses:', totalResponseCount);
//     //console.log('Unavailable responses:', unavailableResponseCount);
//     //console.log('Queries with unavailable responses:', queriesWithUnavailableResponse);

//     } catch (error) {
//       console.error('Error:', error);
//     } finally {
//       setIsLoading(false);
//     }

//   return { totalResponseCount, unavailableResponseCount, queriesWithUnavailableResponse, queriesWithUnresolvedResponse };
// };

//   // Fetch chat history and pass the session IDs to fetchAllSessionHistories
//   const fetchChatHistory = async () => {
//     setIsLoading(true);
//     const email = username;
//     const url = new URL('https://infia.enviseer.com/api/llm/sessions');

//     try {
//       const response = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ email }),
//       });

//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }

//       const data = await response.json();
//       const sessionIdsList = data.reverse().map(session => session.session_id); // Extract session IDs

//     // Call the function to fetch all session histories and process them
//     const { totalResponseCount, unavailableResponseCount, queriesWithUnavailableResponse, queriesWithUnresolvedResponse } = await fetchAllSessionHistories(sessionIdsList);

//     // Display or process the results as needed
//     //console.log("Total responses:", totalResponseCount);
//     //console.log("Unavailable responses:", unavailableResponseCount);
//     //console.log("Queries with unavailable responses:", queriesWithUnavailableResponse);
//     setTotalResponse(totalResponseCount);
//     setUnavailableResponse(unavailableResponseCount);
//     setUnavailableQueries(queriesWithUnavailableResponse);
//     setUnresolvedQueries(queriesWithUnresolvedResponse);
//     setIsLoading(false);
//   } catch (error) {
//     console.error('Error fetching chat history:', error);
//     setIsLoading(false);
//   }
// };

const fetchAllHistories = async () => {
  setIsLoading(true);

  let allHistories = []; // To store all chat histories
  let totalResponseCount = 0; // To count total responses
  let unavailableResponseCount = 0; // To count unavailable responses
  let queriesWithUnresolvedResponse = {
    query: [],
    response: []
  };
  let queriesWithUnavailableResponse = []; // To store queries with unavailable responses

  try {
    // Fetch all chat histories for the company
    const response = await fetch(`https://infia.enviseer.com/api/llm_backend/conversation_history/all?company=${companyName}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch chat histories');
    }

    const data = await response.json();
    allHistories = data;

    // Process each history item
    allHistories.forEach((item) => {
      const { bot_response, feedback, user_input } = item;

      if (bot_response) {
        totalResponseCount++;
        
        // Check for unresolved responses (feedback = -1)
        if (feedback === -1) {
          queriesWithUnresolvedResponse.response.push(bot_response);
          queriesWithUnresolvedResponse.query.push(user_input);
        }

        // Check for unavailable responses
        if (bot_response.includes("The required information is not available in the current context") ||
            bot_response.includes("information in the provided context") ||
            bot_response.includes("provide more context") ||
            bot_response.includes("not contain any information")) {
          unavailableResponseCount++;
          queriesWithUnavailableResponse.push(user_input);
        }
      }
    });

    // Log and set results to state
    //console.log('All chat histories fetched:', allHistories);
    //console.log('Total responses:', totalResponseCount);
    //console.log('Unavailable responses:', unavailableResponseCount);
    //console.log('Queries with unavailable responses:', queriesWithUnavailableResponse);
    //console.log('Unresolved responses:', queriesWithUnresolvedResponse);

    setTotalResponse(totalResponseCount);
    setUnavailableResponse(unavailableResponseCount);
    setUnavailableQueries(queriesWithUnavailableResponse);
    setUnresolvedQueries(queriesWithUnresolvedResponse);

  } catch (error) {
    console.error('Error fetching chat histories:', error);
  } finally {
    setIsLoading(false);
  }
};

const handleDownload = (doc) => {

  const url = `https://infia.enviseer.com/api/llm/download_pdf?company=${companyName}&doc_type=HR&filename=${doc}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`, // Add the Authorization header with the token
    },
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to download file');
      }
      return response.blob(); // Convert response to a blob (binary data)
    })
    .then(blob => {
      // Create a URL for the blob
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = doc; // Use the document name for the download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Error downloading document:', error);
      alert('Failed to download document');
    });
};


  return (
    <div className="admin-view-container">
      <div className="access-management-section">

        <div className="header-container">
          <span className="header">Overview</span>
        </div>

        <div className="overview_parent">

          <div className="analytics-section">
            <div className="metric-box">
              <i className="bi bi-people-fill metric-icon"></i> {/* Bootstrap icon for Unique Customers */}
              <div className="metric-text">
                <h3>{userCount}</h3>
                <p>Unique Users</p>
              </div>
            </div>
            <div className="metric-box">
              <i className="bi bi-archive-fill metric-icon"></i> {/* Bootstrap icon for Total Sessions */}
              <div className="metric-text">
                <h3>{sessionCount}</h3>
                <p>Total Sessions</p>
              </div>
            </div>
            <div className="metric-box">
              <i className="bi bi-chat-left-dots metric-icon"></i> {/* Bootstrap icon for Total Messages */}
              <div className="metric-text">
                <h3>{messageCount}</h3>
                <p>Total Messages</p>
              </div>
            </div>
            <div className="metric-box">
              <i className="bi bi-hourglass-split metric-icon"></i>
              <div className="metric-text">
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <h3>{Math.round(((totalResponse - unavailableResponse) / totalResponse) * 100)} %</h3>
                </div>

                <p>Query Relevance Rate</p>
              </div>
            </div>
          </div>

          <div className="profile-of-people-section">
            <p style={{ fontSize: '18px', fontWeight: '600' }}>Response Quality</p>
            <div className="response-analytics-container">
              <SemiCircleProgressBar percentage={percentage} />
              <div className="stats-column">
                <div className="stat"><i className="bi bi-hand-thumbs-up-fill" style={{ color: 'green' }}></i>
                  <div style={{ fontWeight: 'bolder', color: 'green', fontSize: '20px', marginLeft: '12px' }}>{thumbsUpCount}</div>
                  {/* <i className="bi bi-hand-thumbs-up-fill" style={{ marginLeft: '10px', color: 'green' }}></i> */}
                </div>
                <div className="stat"><i className="bi bi-hand-thumbs-down-fill" style={{ color: 'red' }}></i>
                  <div style={{ fontWeight: 'bolder', color: 'red', fontSize: '20px', marginLeft: '12px' }}>{thumbsDownCount}</div>
                  {/* <i className="bi bi-hand-thumbs-down-fill" style={{ marginLeft: '10px', color: '#e63946' }}></i> */}
                </div>
              </div>
            </div>
            <p></p>
          </div>

          <div className="trending-questions">
            <p style={{ fontSize: '18px', fontWeight: '600' }}>Trending Questions</p>
            <div className="scrollable-content">
              <ul>
                {faqs.map((faq, index) => (
                  <li key={index}>{faq.question}</li>
                ))}
              </ul>
            </div>
          </div>

        </div>

        <div className="access_management_parent">
          <div className="header-container">
            <span className="header">Access Management</span>
            <input
              type="text"
              placeholder="Search by name..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="search-input"
            />
          </div>

          <div className="user-category">
            <table className="user-table">
              <thead>
                <tr>
                  <th>Department</th>
                  <th>Total Users</th>
                  <th>Sessions</th>
                  <th>Messages</th>
                  <th>Manage Access</th>
                  <th>Documents</th>
                  <th>Report</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(departmentData).map((department, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td>
                        <span
                          style={{ cursor: 'pointer', fontWeight: 'bold' }}
                          onClick={() => handleToggleDepartment(department)}
                        >
                          {/* {departmentsToExpand.includes(department) || expandedDepartments.includes(department) ? '▼' : '▶'} {department} */}
                          {departmentsToExpand.includes(department) || expandedDepartments.includes(department) ?
                            <span>
                              <i className="bi-caret-down-fill"></i> {department}
                            </span>
                            :
                            <span>
                              <i className="bi-caret-right-fill"></i> {department}
                            </span>
                          }
                        </span>
                      </td>
                      <td>{departmentData[department].totalUsers}</td>
                      <td>{departmentData[department].sessions}</td>
                      <td>{departmentData[department].messages}</td>
                      <td>
                        <div className="custom-select-wrapper">
                          <select className="custom-select-dropdown" onChange={(e) => {
                            const action = e.target.value;
                            if (action === "Enable All") handleEnableAll(department);
                            else if (action === "Disable All") handleDisableAll(department);
                            else if (action === "Manage Access") handleManageUsers(department);
                          }}
                            disabled={departmentData[department].status !== 'open'}>
                            <option value="">Select</option>
                            <option value="Enable All">Enable for All</option>
                            <option value="Disable All">Disable for All</option>
                            <option value="Manage Access">Manage Users</option>
                          </select>
                        </div>
                      </td>
                      <td style={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
                        {/* Hidden file input */}
                        <input
                          type="file"
                          style={{ display: 'none' }}
                          id={`file-upload-${department}`}
                          onChange={(event) => handleUploadClick(event, department)}
                          disabled={departmentData[department].status !== 'open'}
                        />

        {/* Button to trigger file input click */}
        <button
          type="button"
          className="btn btn-secondary"
          style={{ marginRight: '12px', height:'100%', alignSelf:'center' }}
          onClick={handleSeeAllClick}
          disabled={departmentData[department].status!=='open'}
        >
          <i className="bi bi-file-image"></i> See All Docs
          </button>
          <div
          title={departmentData[department].status !== 'open' ? "Upload is disabled because the status is not open" : uploadedDocs.length === 1? "you've already uploaded a document." :
            "Processing the uploaded document, please wait..." }>
        <button
          type="button"
          className="btn btn-primary"
          style={{height:'100%', alignSelf:'center'}}
          onClick={() => document.getElementById(`file-upload-${department}`).click()}
          disabled={departmentData[department].status!=='open'||uploadedDocs.length===1||loading===department}
          
        >
          <i className="bi bi-upload"></i> {loading===department? 'Uploading':'Upload'}
        </button></div>
          {loading===department && trained===null && (
             <div className="loading-container" style={{display:'flex',alignItems:'center'}}>
               <img src={loader} alt="Training..." style={{ width: '70px', height: '60px', verticalAlign: 'middle' }}/> {/* Show hourglass gif */}
             </div>
          )
          }

                        {loading === null && trained === department && (
                          <div>
                            <p>Ready To Use</p>
                          </div>
                        )}
                      </td>
                      <td><button
                        type="button"
                        className="btn btn-secondary"
                        style={{ marginLeft: '10px', fontSize: '15px' }}
                        onClick={handleGenerateReport}
                        disabled={departmentData[department].status !== 'open'}
                      >
                        <i className="bi bi-file-earmark-text-fill"></i> Generate Report
                      </button>
                      </td>
                      <td>{departmentData[department].status === 'open' ? <i className="bi bi-unlock-fill" style={{ color: '#5E17EB', fontSize: '18px' }}></i> : <i className="bi bi-lock-fill" style={{ color: '#5E17EB', fontSize: '18px' }}></i>}</td>
                      <Modal
  show={showModal}
  onHide={handleClose}
  backdrop={true} /* Disable the dark backdrop */
  className="documents"
>
  <Modal.Header closeButton>
    <Modal.Title>Uploaded Documents</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {uploadedDocs.length > 0 ? (
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        {uploadedDocs.map((doc, index) => (
          <li key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={selectedDocs.includes(doc)}
              onChange={() => handleSelect(doc)}
              style={{ marginRight: '12px' }}
            />
            <span>{doc}</span>
            {/* Download button */}
            <Button
              variant="link"
              onClick={() => handleDownload(doc)}
              style={{ marginLeft: 'auto', textDecoration: 'none', color: '#007bff' }}
            >
              Download
            </Button>
          </li>
        ))}
      </ul>
    ) : (
      <p>No documents uploaded yet.</p>
    )}
  </Modal.Body>
  <Modal.Footer style={{ justifyContent: 'space-between' }}>
    <Button variant="secondary" onClick={handleClose}>
      Close
    </Button>
    {selectedDocs.length > 0 && (
      <Button variant="danger" onClick={deletePDFs}>
        Remove Documents
      </Button>
    )}
  </Modal.Footer>
</Modal>


    {showReport && report && (
        <Modal show={true} onHide={handleClose} backdrop={false} className='showReport'>
        <Modal.Header closeButton onClick={handleReportClose}>
          <Modal.Title>Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="report-summary" style={{ marginBottom: "20px" }}>
            <h5>Report Summary</h5>
            <p>Department: <strong>HR</strong></p>
            <p>Total Users: <strong>{departmentData['HR'].totalUsers}</strong></p>
            <p>Total Sessions: <strong>{departmentData['HR'].sessions}</strong></p>
            <p>Total Messages: <strong>{departmentData['HR'].messages}</strong></p>
            <p>Query Relevance Rate: <strong>{ Math.round(((totalResponse - unavailableResponse) / totalResponse) * 100)} %</strong></p>
            <p>Response Quality: <strong>{percentage}%</strong></p>
          </div>
      
          <h5>Request Summary</h5>
          <ul>
            <li>Total Unresolved Requests: <strong>{unresolvedQueries.query.length}</strong></li>
            <li>Total Irrelevant Requests: <strong>{unavailableQueries.length}</strong></li>
          </ul>
      
          <div className="download-buttons">
            <h5>Download Options:</h5>
            <Button variant="link" onClick={handleDownloadUnresolvedRequests}>
              • Download Unresolved Requests
            </Button>
            <Button variant="link" onClick={handleDownloadUnresolvedWithResponse}>
              • Download Unresolved Requests with Response
            </Button>
            <Button variant="link" onClick={handleDownloadIrrelevantRequests}>
              • Download Irrelevant Requests
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleDownloadWholeReport}>
           Download
          </Button>
          <Button variant="secondary" onClick={handleReportClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      
       
      )}

                    </tr>
                    {(departmentsToExpand.includes(department) || expandedDepartments.includes(department)) && departmentData[department].status === 'open' && (
                      <tr>
                        <td colSpan="5">
                          <table className="user-subtable">
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {departmentDataforAdmin[department].users.map((user, idx) => (
                                filteredUsers.includes(user) && (
                                  <tr key={user.id}>
                                    <td>{idx + 1}</td>
                                    <td>{user.name}</td>
                                    <td>
                                    <div style={{ position: 'relative' }}>
                                      <button
                                        className={`status-button ${user.status.toLowerCase()}`}
                                        onClick={() => toggleStatus(user.id)}
                                        onMouseEnter={() => setVisibleTooltipId(user.id)}
                                        onMouseLeave={() => setVisibleTooltipId(null)}
                                      >
                                        {user.status}
                                      </button>
                                      {visibleTooltipId === user.id && (
                                        <div className="tooltip">
                                          {user.status === 'Enabled' ? 'Click to disable' : 'Click to enable'}
                                        </div>
                                      )}
                                      </div>
                                    </td>
                                  </tr>
                                )
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AdminView;
